<template>
    <div id="sundair-login" class="travelo-login-box sdr-box">
        <div class="seperator"><label>Hello</label></div>
        <br />
        <form @submit.prevent="onSubmit">
            <div class="form-group">
                <input type="text" class="input-text full-width" placeholder="agency login" v-model="agency_login">
            </div>
            <div class="form-group">
                <input type="password" class="input-text full-width" placeholder="password" v-model="agency_password">
            </div>
            <br /><br />
            <!-- <div class="form-group">
                <a class="forgot-password pull-right">Forgot password?</a>
                <div class="checkbox checkbox-inline">
                    <label>
                        <input type="checkbox"> Remember me
                    </label>
                </div>
            </div> -->
            <button class="btn-medium uppercase full-width"><i class="soap-icon-trunk-1"></i>&nbsp;&nbsp;Login with Agency</button>
        </form>
        <div class="seperator"></div>
        <p>Don't have an account?&nbsp;&nbsp;<a class="goto-signup soap-popupbox">+49 30 46 79 76 00</a></p>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';
    import md5 from 'js-md5';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                language: {
                    en: 'Language',
                    de: 'Sprache',
                },
                // >>> ------------------------------------
                agency_login: '',
                agency_password: '',
                // >>> ------------------------------------
                lang: 'de'
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setCurrentLocale',
                'actn_call_GetAgency', // call:
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc:
            * Note: Encrypt here (md5).
            *
            */
            onSubmit: function(submitEvent) {

                let me = this;


                me.$toc('>>> booking/flightsearch/ModifySearchBox.vue >>> onSubmit');
                if (this.agency_login !== '' && this.agency_password !== '') {
                    this.actn_call_GetAgency({ username: this.agency_login, password: md5(this.agency_password) });
                }

            }, // eof onSubmit()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/header/SundairLogin.vue